import Tab from "@mui/material/Tab";
import { Link, Outlet, useLocation } from "react-router-dom";
import React from "react";
import Tabs from "@mui/material/Tabs";

const LinkTab = (props) => <Tab value={props.to} component={Link} {...props} />;
export const RouterTabs = ({ tabs, baseHref }) => {
  const { pathname } = useLocation();
  const tabsMapped =
    baseHref && tabs
      ? tabs.map(({ to, ...tab }) => ({ ...tab, to: `${baseHref}${to}` }))
      : tabs;

  const value = tabsMapped?.findIndex(({ to }) => `${to}` === pathname);
  return (
    <>
      {tabsMapped && value > -1 && (
        <Tabs value={value} sx={{ mb: 5 }}>
          {tabsMapped.map((tab) => (
            <LinkTab key={tab.to} {...tab} />
          ))}
        </Tabs>
      )}
      <Outlet />
    </>
  );
};
